export const optionsEventOwner = [
  {value: 'Table', label: 'Table'},
  {value: 'Field', label: 'Field'},
  {value: 'Chapter', label: 'Chapter'},
  {value: 'Plugin', label: 'Plugin'},
  {value: 'Template', label: 'Template'},
  {value: 'XMLData', label: 'XMLData'},
  {value: 'PluginExtension', label: 'PluginExtension'},
  {value: 'PluginSkin', label: 'PluginSkin'},
  {value: 'EffectSkin', label: 'EffectSkin'},
  {value: 'AddIn', label: 'AddIn'},
  {value: 'AddInTemplate', label: 'AddInTemplate'},
  {value: 'Widget', label: 'Widget'},
  {value: 'WidgetTemplate', label: 'WidgetTemplate'},
  {value: 'APIMethod', label: 'APIMethod'},
  {value: 'PortletTemplate', label: 'PortletTemplate'},
  {value: 'Portlet', label: 'Portlet'}
]

export const optionsEventKind = [
  {value: '', label: ''},
  {value: 'ASPClientBeforeSubmit', label: 'ASPClientBeforeSubmit'},
  {value: 'ASPSourceAfterCommit', label: 'ASPSourceAfterCommit'},
  {value: 'ASPSourceOnAfterFieldSheetShowOne', label: 'ASPSourceOnAfterFieldSheetShowOne'},
  {value: 'ASPSourceOnAfterFieldsSheetShowOneTable', label: 'ASPSourceOnAfterFieldsSheetShowOneTable'},
  {value: 'ASPSourceOnAfterSearch', label: 'ASPSourceOnAfterSearch'},
  {value: 'ASPSourceOnAfterSheetShowOneTable', label: 'ASPSourceOnAfterSheetShowOneTable'},
  {value: 'ASPSourceOnAfterShowOneTable', label: 'ASPSourceOnAfterShowOneTable'},
  {value: 'ASPSourceOnBeforeFieldSheetShowOne', label: 'ASPSourceOnBeforeFieldSheetShowOne'},
  {value: 'ASPSourceOnBeforeFieldsSheetShowOneTable', label: 'ASPSourceOnBeforeFieldsSheetShowOneTable'},
  {value: 'ASPSourceOnBeforeGetData', label: 'ASPSourceOnBeforeGetData'},
  {value: 'ASPSourceOnBeforeSheetShowOneTable', label: 'ASPSourceOnBeforeSheetShowOneTable'},
  {value: 'ASPSourceOnBeforeShowOne', label: 'ASPSourceOnBeforeShowOne'},
  {value: 'ASPSourceOnBeforeShowOneTable', label: 'ASPSourceOnBeforeShowOneTable'},
  {value: 'ASPSourceOnDelete', label: 'ASPSourceOnDelete'},
  {value: 'ASPSourceOnFieldValue', label: 'ASPSourceOnFieldValue'},
  {value: 'ASPSourceOnFilter', label: 'ASPSourceOnFilter'},
  {value: 'ASPSourceOnValueChange', label: 'ASPSourceOnValueChange'},
  {value: 'ASPSourceOnValueGetInfo', label: 'ASPSourceOnValueGetInfo'},
  {value: 'ASPSourcePreSubmitCheck', label: 'ASPSourcePreSubmitCheck'},
  {value: 'ASPSourceShowAfter', label: 'ASPSourceShowAfter'},
  {value: 'ASPSourceShowBefore', label: 'ASPSourceShowBefore'},
  {value: 'ASPSourceShowFields', label: 'ASPSourceShowFields'},
  {value: 'ASPSourceShowFieldsAfter', label: 'ASPSourceShowFieldsAfter'},
  {value: 'ASPSourceShowFieldsBefore', label: 'ASPSourceShowFieldsBefore'},
  {value: 'ASPSourceShowFieldsStart', label: 'ASPSourceShowFieldsStart'},
  {value: 'ASPSourceSubmit', label: 'ASPSourceSubmit'},
  {value: 'ASPSourceSubmitBefore', label: 'ASPSourceSubmitBefore'},
  {value: 'OnASPPageAfter', label: 'OnASPPageAfter'},
  {value: 'OnASPPageBefore', label: 'OnASPPageBefore'},
  {value: 'OnASPPageContent', label: 'OnASPPageContent'},
  {value: 'OnASPPageHeader', label: 'OnASPPageHeader'},
  {value: 'OnASPPageNamedSection', label: 'OnASPPageNamedSection'},
  {value: 'OnASPPageTop', label: 'OnASPPageTop'},
  {value: 'OnASPWriteFile', label: 'OnASPWriteFile'},
  {value: 'OnAfterExecute', label: 'OnAfterExecute'},
  {value: 'OnAppPageAUChapterChanged', label: 'OnAppPageAUChapterChanged'},
  {value: 'OnAppPageBeforeMainTab', label: 'OnAppPageBeforeMainTab'},
  {value: 'OnAppPageSOButton', label: 'OnAppPageSOButton'},
  {value: 'OnAppPageSOSection', label: 'OnAppPageSOSection'},
  {value: 'OnBeforeExecute', label: 'OnBeforeExecute'},
  {value: 'OnCMS5', label: 'OnCMS5'},
  {value: 'OnCMSAfterCheck', label: 'OnCMSAfterCheck'},
  {value: 'OnCMSAfterGetData', label: 'OnCMSAfterGetData'},
  {value: 'OnCMSAfterMain', label: 'OnCMSAfterMain'},
  {value: 'OnCMSAfterSubmit', label: 'OnCMSAfterSubmit'},
  {value: 'OnCMSAlertBeforeDetail', label: 'OnCMSAlertBeforeDetail'},
  {value: 'OnCMSBeforeCheck', label: 'OnCMSBeforeCheck'},
  {value: 'OnCMSBeforeGetData', label: 'OnCMSBeforeGetData'},
  {value: 'OnCMSBeforeMain', label: 'OnCMSBeforeMain'},
  {value: 'OnCMSBeforeSingleViewGetData', label: 'OnCMSBeforeSingleViewGetData'},
  {value: 'OnCMSBeforeSubmit', label: 'OnCMSBeforeSubmit'},
  {value: 'OnCMSChapterInit', label: 'OnCMSChapterInit'},
  {value: 'OnCMSChapterMenuAfter', label: 'OnCMSChapterMenuAfter'},
  {value: 'OnCMSChapterMenuBefore', label: 'OnCMSChapterMenuBefore'},
  {value: 'OnCMSContentTemplate', label: 'OnCMSContentTemplate'},
  {value: 'OnCMSGetAlertJSON', label: 'OnCMSGetAlertJSON'},
  {value: 'OnCMSGetDefaultValues', label: 'OnCMSGetDefaultValues'},
  {value: 'OnCMSInit', label: 'OnCMSInit'},
  {value: 'OnCMSPageBottomAfter', label: 'OnCMSPageBottomAfter'},
  {value: 'OnCMSPageBottomBefore', label: 'OnCMSPageBottomBefore'},
  {value: 'OnCMSPageContent', label: 'OnCMSPageContent'},
  {value: 'OnCMSPageContentAfter', label: 'OnCMSPageContentAfter'},
  {value: 'OnCMSPageContentAfterStart', label: 'OnCMSPageContentAfterStart'},
  {value: 'OnCMSPageContentBefore', label: 'OnCMSPageContentBefore'},
  {value: 'OnCMSPageContentBeforeEnd', label: 'OnCMSPageContentBeforeEnd'},
  {value: 'OnCMSPageHeader', label: 'OnCMSPageHeader'},
  {value: 'OnCMSPageLeftAfter', label: 'OnCMSPageLeftAfter'},
  {value: 'OnCMSPageLeftBefore', label: 'OnCMSPageLeftBefore'},
  {value: 'OnCMSPageNamedSection', label: 'OnCMSPageNamedSection'},
  {value: 'OnCMSPageRightAfter', label: 'OnCMSPageRightAfter'},
  {value: 'OnCMSPageRightBefore', label: 'OnCMSPageRightBefore'},
  {value: 'OnCMSPageTemplate', label: 'OnCMSPageTemplate'},
  {value: 'OnCMSPageTopAfter', label: 'OnCMSPageTopAfter'},
  {value: 'OnCMSPageTopBefore', label: 'OnCMSPageTopBefore'},
  {value: 'OnCMSSQLCreate', label: 'OnCMSSQLCreate'},
  {value: 'OnCMSSubmit', label: 'OnCMSSubmit'},
  {value: 'OnCMSWrite', label: 'OnCMSWrite'},
  {value: 'OnCMSWriteCSS', label: 'OnCMSWriteCSS'},
  {value: 'OnCMSWriteCSSSingle', label: 'OnCMSWriteCSSSingle'},
  {value: 'OnCMSWriteChapterAfter', label: 'OnCMSWriteChapterAfter'},
  {value: 'OnCMSWriteChapterCSS', label: 'OnCMSWriteChapterCSS'},
  {value: 'OnCMSWriteChapterJS', label: 'OnCMSWriteChapterJS'},
  {value: 'OnCMSWriteChapterText', label: 'OnCMSWriteChapterText'},
  {value: 'OnCMSWriteChapterXSLSingle', label: 'OnCMSWriteChapterXSLSingle'},
  {value: 'OnCMSWriteChapterXSLTable', label: 'OnCMSWriteChapterXSLTable'},
  {value: 'OnCMSWriteJS', label: 'OnCMSWriteJS'},
  {value: 'OnCMSWriteXML', label: 'OnCMSWriteXML'},
  {value: 'OnCMSWriteXSD', label: 'OnCMSWriteXSD'},
  {value: 'OnCMSWriteXSL', label: 'OnCMSWriteXSL'},
  {value: 'OnCacheGet', label: 'OnCacheGet'},
  {value: 'OnExecute', label: 'OnExecute'},
  {value: 'OnExtensionAction', label: 'OnExtensionAction'},
  {value: 'OnExtensionExecute', label: 'OnExtensionExecute'},
  {value: 'OnGetCSS', label: 'OnGetCSS'},
  {value: 'OnGetCSSSource', label: 'OnGetCSSSource'},
  {value: 'OnGetScript', label: 'OnGetScript'},
  {value: 'OnGetScriptSource', label: 'OnGetScriptSource'},
  {value: 'OnPluginAfter', label: 'OnPluginAfter'},
  {value: 'OnPluginBefore', label: 'OnPluginBefore'},
  {value: 'OnProjectInit', label: 'OnProjectInit'},
  {value: 'OnProjectSQLCreate', label: 'OnProjectSQLCreate'},
  {value: 'OnProjectWrite', label: 'OnProjectWrite'},
  {value: 'OnProjectWritePageAll', label: 'OnProjectWritePageAll'},
  {value: 'OnRSSClose', label: 'OnRSSClose'},
  {value: 'OnRSSGetDescription', label: 'OnRSSGetDescription'},
  {value: 'OnRSSGetLink', label: 'OnRSSGetLink'},
  {value: 'OnRSSGetTitle', label: 'OnRSSGetTitle'},
  {value: 'OnRSSItem', label: 'OnRSSItem'},
  {value: 'OnRSSOpen', label: 'OnRSSOpen'},
  {value: 'OnSQLCreate', label: 'OnSQLCreate'},
  {value: 'OnSQLGet', label: 'OnSQLGet'},
  {value: 'OnSchedulerDay', label: 'OnSchedulerDay'},
  {value: 'OnSchedulerHour', label: 'OnSchedulerHour'},
  {value: 'OnSchedulerMinute', label: 'OnSchedulerMinute'},
  {value: 'OnSchedulerMinute11', label: 'OnSchedulerMinute11'},
  {value: 'OnSchedulerMinute23', label: 'OnSchedulerMinute23'},
  {value: 'OnSchedulerMinute31', label: 'OnSchedulerMinute31'},
  {value: 'OnSchedulerMinute5', label: 'OnSchedulerMinute5'},
  {value: 'OnSchedulerMonth', label: 'OnSchedulerMonth'},
  {value: 'OnSchedulerWeek', label: 'OnSchedulerWeek'},
  {value: 'OnTableXMLLoad', label: 'OnTableXMLLoad'},
  {value: 'OnUserAdd', label: 'OnUserAdd'},
  {value: 'OnUserAuthenticate', label: 'OnUserAuthenticate'},
  {value: 'OnUserChange', label: 'OnUserChange'},
  {value: 'OnUserDelete', label: 'OnUserDelete'},
  {value: 'OnUserLogin', label: 'OnUserLogin'},
  {value: 'OnUserLoginFailed', label: 'OnUserLoginFailed'},
  {value: 'OnUserLogout', label: 'OnUserLogout'},
  {value: 'OnWidgetGetCSS', label: 'OnWidgetGetCSS'},
  {value: 'OnWidgetGetScript', label: 'OnWidgetGetScript'},
  {value: 'OnWidgetGetServerMethod', label: 'OnWidgetGetServerMethod'},
  {value: 'OnWidgetGetTemplate', label: 'OnWidgetGetTemplate'},
  {value: 'OnWidgetInit', label: 'OnWidgetInit'},
  {value: 'OnXMLDataBeforeClose', label: 'OnXMLDataBeforeClose'},
  {value: 'OnXMLDataClose', label: 'OnXMLDataClose'},
  {value: 'OnXMLDataIndex', label: 'OnXMLDataIndex'},
  {value: 'OnXMLDataItem', label: 'OnXMLDataItem'},
  {value: 'OnXMLDataOpen', label: 'OnXMLDataOpen'},
  {value: 'OnXMLGet', label: 'OnXMLGet'},
  {value: 'SchedulerOnValueChange', label: 'SchedulerOnValueChange'}
]
